var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "pdv-dash"
  }, [_c('div', {
    staticClass: "pdv-dash__cards"
  }, [_vm.carregando ? _vm._l(3, function (n) {
    return _c('div', {
      key: 'sk-' + n,
      staticClass: "pdv-dash__card pdv-dash__card--skeleton"
    }, [_c('div', {
      staticClass: "pdv-dash__skeleton-icon"
    }), _vm._m(0, true)]);
  }) : [_c('div', {
    staticClass: "pdv-dash__card"
  }, [_vm._m(1), _c('div', {
    staticClass: "pdv-dash__card-info"
  }, [_c('span', {
    staticClass: "pdv-dash__card-label"
  }, [_vm._v("Produtos sincronizados")]), _c('span', {
    staticClass: "pdv-dash__card-value"
  }, [_vm._v(_vm._s(_vm._f("numero")(_vm.resumo.produtos_total)))]), _c('span', {
    staticClass: "pdv-dash__card-sub"
  }, [_vm._v("Produtos disponíveis no terminal")])])]), _c('div', {
    staticClass: "pdv-dash__card"
  }, [_vm._m(2), _c('div', {
    staticClass: "pdv-dash__card-info"
  }, [_c('span', {
    staticClass: "pdv-dash__card-label"
  }, [_vm._v("Clientes sincronizados")]), _c('span', {
    staticClass: "pdv-dash__card-value"
  }, [_vm._v(_vm._s(_vm._f("numero")(_vm.resumo.clientes_total)))]), _c('span', {
    staticClass: "pdv-dash__card-sub"
  }, [_vm._v("Clientes disponíveis offline")])])]), _c('div', {
    staticClass: "pdv-dash__card"
  }, [_vm._m(3), _c('div', {
    staticClass: "pdv-dash__card-info"
  }, [_c('span', {
    staticClass: "pdv-dash__card-label"
  }, [_vm._v("Vendas concluídas")]), _c('span', {
    staticClass: "pdv-dash__card-value"
  }, [_vm._v(_vm._s(_vm._f("numero")(_vm.resumo.nfces_total)))]), _c('span', {
    staticClass: "pdv-dash__card-sub"
  }, [_vm._v("Autorizadas ou finalizadas neste terminal")])])])]], 2), _c('div', {
    staticClass: "pdv-dash__atalhos"
  }, [_c('button', {
    staticClass: "pdv-dash__atalho pdv-dash__atalho--primary",
    on: {
      "click": _vm.irParaNovaVenda
    }
  }, [_c('i', {
    staticClass: "fas fa-plus-circle"
  }), _c('span', [_vm._v("Nova venda")])]), _c('button', {
    staticClass: "pdv-dash__atalho pdv-dash__atalho--secondary",
    on: {
      "click": _vm.irParaVendas
    }
  }, [_c('i', {
    staticClass: "fas fa-list-alt"
  }), _c('span', [_vm._v("Vendas")])]), _c('button', {
    staticClass: "pdv-dash__atalho pdv-dash__atalho--outline",
    attrs: {
      "disabled": _vm.sincronizando || !_vm.online
    },
    on: {
      "click": _vm.sincronizarAgora
    }
  }, [_c('i', {
    class: _vm.sincronizando ? 'fas fa-spinner fa-spin' : 'fas fa-sync-alt'
  }), _c('span', [_vm._v(_vm._s(_vm.sincronizando ? "Sincronizando..." : "Sincronizar"))])])]), _vm.sincronizando ? _c('div', {
    staticClass: "pdv-dash__sync-bar"
  }, [_c('div', {
    staticClass: "progress",
    staticStyle: {
      "height": "6px",
      "border-radius": "4px"
    }
  }, [_c('div', {
    staticClass: "progress-bar progress-bar-striped progress-bar-animated",
    style: {
      width: _vm.progressoSync + '%'
    },
    attrs: {
      "role": "progressbar"
    }
  })]), _c('small', {
    staticClass: "pdv-dash__sync-msg"
  }, [_vm._v(_vm._s(_vm.statusSync))])]) : _vm._e(), _c('transition', {
    attrs: {
      "name": "pdv-fade"
    }
  }, [_vm.msgSucesso ? _c('div', {
    staticClass: "pdv-dash__alert pdv-dash__alert--success"
  }, [_c('i', {
    staticClass: "fas fa-check-circle mr-2"
  }), _vm._v(_vm._s(_vm.msgSucesso) + " ")]) : _vm._e()]), _c('transition', {
    attrs: {
      "name": "pdv-fade"
    }
  }, [_vm.msgErro ? _c('div', {
    staticClass: "pdv-dash__alert pdv-dash__alert--danger"
  }, [_c('i', {
    staticClass: "fas fa-exclamation-triangle mr-2"
  }), _vm._v(_vm._s(_vm.msgErro) + " ")]) : _vm._e()]), _c('div', {
    staticClass: "pdv-dash__content"
  }, [_c('div', {
    staticClass: "pdv-dash__panel"
  }, [_vm._m(4), _c('div', {
    staticClass: "pdv-dash__panel-body"
  }, [_vm.carregandoGrafico ? [_vm._m(5)] : _vm.produtosMaisVendidos.length ? [_c('apexchart', {
    attrs: {
      "type": "donut",
      "height": "280",
      "options": _vm.chartOptions,
      "series": _vm.chartSeries
    }
  })] : _c('div', {
    staticClass: "pdv-dash__empty"
  }, [_c('i', {
    staticClass: "fas fa-chart-pie fa-2x mb-2 text-muted"
  }), _c('p', [_vm._v("Nenhuma venda registrada nesta semana.")])])], 2)]), _c('div', {
    staticClass: "pdv-dash__panel"
  }, [_vm._m(6), _c('div', {
    staticClass: "pdv-dash__panel-body"
  }, [_vm.carregandoGrafico ? [_vm._m(7)] : _vm.vendasPorGrupo.length ? [_c('apexchart', {
    attrs: {
      "type": "bar",
      "height": "280",
      "options": _vm.chartOptionsGrupos,
      "series": _vm.chartSeriesGrupos
    }
  })] : _c('div', {
    staticClass: "pdv-dash__empty"
  }, [_c('i', {
    staticClass: "fas fa-tags fa-2x mb-2 text-muted"
  }), _c('p', [_vm._v("Sem dados de grupos/categorias para o período.")])])], 2)])]), _vm.modalSettings ? _c('div', {
    staticClass: "pdv-dash__overlay",
    on: {
      "click": function click($event) {
        if ($event.target !== $event.currentTarget) return null;
        _vm.modalSettings = false;
      }
    }
  }, [_c('div', {
    staticClass: "pdv-dash__modal"
  }, [_c('div', {
    staticClass: "pdv-dash__modal-header"
  }, [_vm._m(8), _c('button', {
    staticClass: "pdv-dash__btn-close",
    on: {
      "click": function click($event) {
        _vm.modalSettings = false;
      }
    }
  }, [_vm._v("✕")])]), _c('div', {
    staticClass: "pdv-dash__modal-body"
  }, [_c('div', {
    staticClass: "pdv-dash__settings-section"
  }, [_c('p', {
    staticClass: "pdv-dash__settings-section-title"
  }, [_vm._v("Dados do Terminal")]), _c('table', {
    staticClass: "pdv-dash__settings-table"
  }, [_c('tr', [_c('td', [_vm._v("UUID do terminal")]), _c('td', [_c('code', [_vm._v(_vm._s(_vm.terminal.uuid_terminal || "—"))])])]), _c('tr', [_c('td', [_vm._v("Nome")]), _c('td', [_vm._v(_vm._s(_vm.terminal.nome || "—"))])]), _c('tr', [_c('td', [_vm._v("Terminal")]), _c('td', [_vm._v(_vm._s(_vm.terminal.nome || _vm.terminal.id_terminal_venda || "—"))])]), _c('tr', [_c('td', [_vm._v("Empresa (ID)")]), _c('td', [_vm._v(_vm._s(_vm.terminal.id_empresa || "—"))])]), _c('tr', [_c('td', [_vm._v("Status")]), _c('td', [_c('span', {
    class: ['pdv-dash__tag', _vm.online ? 'pdv-dash__tag--green' : 'pdv-dash__tag--red']
  }, [_vm._v(" " + _vm._s(_vm.online ? "Online" : "Offline") + " ")])])]), _c('tr', [_c('td', [_vm._v("Última sincronização")]), _c('td', [_vm._v(_vm._s(_vm._formatarData(_vm.resumo.ultima_sincronizacao)))])]), _c('tr', [_c('td', [_vm._v("Última validação")]), _c('td', [_vm._v(_vm._s(_vm._formatarData(_vm.terminal.terminal_validado_em || _vm.terminal.terminal_ultimo_acesso_em)))])]), _c('tr', [_c('td', [_vm._v("Vendas pendentes")]), _c('td', [_c('span', {
    class: ['pdv-dash__tag', _vm.resumo.vendas_pendentes > 0 ? 'pdv-dash__tag--orange' : 'pdv-dash__tag--neutral']
  }, [_vm._v(" " + _vm._s(_vm.resumo.vendas_pendentes) + " ")])])]), _c('tr', [_c('td', [_vm._v("Caixa pendente")]), _c('td', [_c('span', {
    class: ['pdv-dash__tag', _vm.resumo.caixa_pendente > 0 ? 'pdv-dash__tag--orange' : 'pdv-dash__tag--neutral']
  }, [_vm._v(" " + _vm._s(_vm.resumo.caixa_pendente > 0 ? "Sim" : "Não") + " ")])])])])]), _c('div', {
    staticClass: "pdv-dash__settings-section"
  }, [_c('p', {
    staticClass: "pdv-dash__settings-section-title"
  }, [_vm._v("Configuração NFC-e")]), _c('table', {
    staticClass: "pdv-dash__settings-table"
  }, [_c('tr', [_c('td', [_vm._v("Descrição")]), _c('td', [_vm._v(_vm._s(_vm.dadosTerminal.configuracao ? _vm._nomeConfiguracaoNfce(_vm.dadosTerminal.configuracao) : "—"))])]), _c('tr', [_c('td', [_vm._v("Modelo")]), _c('td', [_vm._v(_vm._s(_vm.dadosTerminal.configuracao && _vm.dadosTerminal.configuracao.modelo || "—"))])]), _c('tr', [_c('td', [_vm._v("Série")]), _c('td', [_vm._v(_vm._s(_vm.dadosTerminal.configuracao && _vm.dadosTerminal.configuracao.serie || _vm.terminal.serie_nfe || "—"))])]), _c('tr', [_c('td', [_vm._v("Próxima nota")]), _c('td', [_vm._v("#" + _vm._s(_vm.dadosTerminal.configuracao && _vm.dadosTerminal.configuracao.proximaNota || "—"))])]), _c('tr', [_c('td', [_vm._v("Ambiente")]), _c('td', [_vm.dadosTerminal.configuracao && _vm.dadosTerminal.configuracao.ambiente == 1 ? _c('span', {
    staticClass: "pdv-dash__tag pdv-dash__tag--red"
  }, [_vm._v("Produção")]) : _vm.dadosTerminal.configuracao && _vm.dadosTerminal.configuracao.ambiente == 2 ? _c('span', {
    staticClass: "pdv-dash__tag pdv-dash__tag--orange"
  }, [_vm._v("Homologação")]) : _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("—")])])])])]), _c('div', {
    staticClass: "pdv-dash__settings-section"
  }, [_c('p', {
    staticClass: "pdv-dash__settings-section-title"
  }, [_vm._v("Impressora")]), _c('table', {
    staticClass: "pdv-dash__settings-table"
  }, [_c('tr', [_c('td', [_vm._v("Impressora padrão")]), _c('td', [_vm._v(_vm._s(_vm.dadosTerminal.impressora && _vm.dadosTerminal.impressora.printer_name || "Padrão do sistema"))])]), _c('tr', [_c('td', [_vm._v("Tipo")]), _c('td', [_vm._v(_vm._s(_vm.dadosTerminal.impressora && _vm.dadosTerminal.impressora.tipo || "—"))])]), _c('tr', [_c('td', [_vm._v("Impressão automática")]), _c('td', [_vm._v(_vm._s(_vm.dadosTerminal.impressora && _vm.dadosTerminal.impressora.impressao_automatica ? "Sim" : "Não"))])])]), _c('button', {
    staticClass: "pdv-dash__modal-btn pdv-dash__settings-action",
    on: {
      "click": _vm.irParaImpressora
    }
  }, [_vm._m(9), _vm._m(10), _c('i', {
    staticClass: "fas fa-chevron-right pdv-dash__settings-action-arrow"
  })])]), _c('div', {
    staticClass: "pdv-dash__settings-section"
  }, [_c('p', {
    staticClass: "pdv-dash__settings-section-title"
  }, [_vm._v("Balança de checkout")]), _c('p', {
    staticClass: "text-muted mb-3"
  }, [_vm._v(" Configure a leitura automática de peso para produtos marcados como pesados. ")]), _c('button', {
    staticClass: "pdv-dash__modal-btn pdv-dash__settings-action",
    on: {
      "click": _vm.irParaBalanca
    }
  }, [_vm._m(11), _vm._m(12), _c('i', {
    staticClass: "fas fa-chevron-right pdv-dash__settings-action-arrow"
  })])])]), _c('div', {
    staticClass: "pdv-dash__modal-footer"
  }, [_c('button', {
    staticClass: "pdv-dash__modal-btn pdv-dash__modal-btn--outline",
    on: {
      "click": _vm._recarregarTerminal
    }
  }, [_c('i', {
    staticClass: "fas fa-redo mr-1"
  }), _vm._v("Recarregar dados ")]), _c('button', {
    staticClass: "pdv-dash__modal-btn pdv-dash__modal-btn--outline",
    attrs: {
      "disabled": !_vm.online || _vm.sincronizandoFiscal
    },
    on: {
      "click": _vm._sincronizarFiscal
    }
  }, [_vm.sincronizandoFiscal ? _c('span', [_c('span', {
    staticClass: "spinner-border spinner-border-sm mr-1"
  }), _vm._v("Sincronizando... ")]) : _c('span', [_c('i', {
    staticClass: "fas fa-file-invoice-dollar mr-1"
  }), _vm._v("Sincronizar fiscal")])]), _c('button', {
    staticClass: "pdv-dash__modal-btn pdv-dash__modal-btn--outline",
    attrs: {
      "disabled": _vm.fazendoBackup
    },
    on: {
      "click": _vm._fazerBackup
    }
  }, [_vm.fazendoBackup ? _c('span', [_c('span', {
    staticClass: "spinner-border spinner-border-sm mr-1"
  }), _vm._v("Fazendo backup... ")]) : _c('span', [_c('i', {
    staticClass: "fas fa-database mr-1"
  }), _vm._v("Criar backup")])])])])]) : _vm._e()], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "pdv-dash__skeleton-lines"
  }, [_c('div', {
    staticClass: "pdv-dash__skeleton-line pdv-dash__skeleton-line--sm"
  }), _c('div', {
    staticClass: "pdv-dash__skeleton-line pdv-dash__skeleton-line--lg"
  }), _c('div', {
    staticClass: "pdv-dash__skeleton-line pdv-dash__skeleton-line--sm"
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "pdv-dash__card-icon pdv-dash__card-icon--blue"
  }, [_c('i', {
    staticClass: "fas fa-box"
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "pdv-dash__card-icon pdv-dash__card-icon--green"
  }, [_c('i', {
    staticClass: "fas fa-users"
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "pdv-dash__card-icon pdv-dash__card-icon--indigo"
  }, [_c('i', {
    staticClass: "fas fa-file-invoice-dollar"
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "pdv-dash__panel-header"
  }, [_c('i', {
    staticClass: "fas fa-chart-pie mr-2 text-primary"
  }), _c('span', [_vm._v("Produtos mais vendidos na semana")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "pdv-dash__chart-placeholder"
  }, [_c('span', {
    staticClass: "spinner-border text-primary"
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "pdv-dash__panel-header"
  }, [_c('i', {
    staticClass: "fas fa-tags mr-2 text-primary"
  }), _c('span', [_vm._v("Vendas por grupo/categoria na semana")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "pdv-dash__chart-placeholder"
  }, [_c('span', {
    staticClass: "spinner-border text-primary"
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('h4', {
    staticClass: "pdv-dash__modal-title"
  }, [_c('i', {
    staticClass: "fas fa-cog mr-2"
  }), _vm._v("Configurações do Terminal ")]), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Dados locais do PDV Desktop")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('span', {
    staticClass: "pdv-dash__settings-action-icon"
  }, [_c('i', {
    staticClass: "fas fa-print"
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('span', [_c('strong', [_vm._v("Configurar impressora")]), _c('small', [_vm._v("Modelo, conexão e impressão automática")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('span', {
    staticClass: "pdv-dash__settings-action-icon"
  }, [_c('i', {
    staticClass: "fas fa-weight"
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('span', [_c('strong', [_vm._v("Configurar balança")]), _c('small', [_vm._v("Conexão e leitura automática de peso")])]);
}];
export { render, staticRenderFns };